import { render } from "./ConfirmLogoutAccountPopup.vue?vue&type=template&id=645db9f3&scoped=true"
import script from "./ConfirmLogoutAccountPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmLogoutAccountPopup.vue?vue&type=script&lang=js"

import "./ConfirmLogoutAccountPopup.vue?vue&type=style&index=0&id=645db9f3&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645db9f3"]])

export default __exports__